import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { api } from "@/api";
import AgentStatsPage from "@/pages/AgentStatsPage";

export default function ShortReportPage() {
  const { code } = useParams();
  const [state, setState] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    api.get(`/report-links/${code}`).then(({ data }) => setState(data)).catch(() => setError(true));
  }, [code]);
  if (error) return <p className="shared-report-msg" data-testid="short-report-error">Ce lien de rapport est introuvable.</p>;
  if (!state) return <p className="shared-report-msg" data-testid="short-report-loading">Chargement du rapport…</p>;
  return <AgentStatsPage shared initialState={state} />;
}
